import React from 'react'
import styles from './giftCardFilterDateField.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'
import { CalendarDateRangePicker, CloseButton } from 'src/chrome'
import { useState } from 'src/hooks'
import moment, { Moment } from 'moment'

export type DateFilter = {
  gte?: string
  lte?: string
  eq?: string
}

type GiftCardFilterDateFieldProps = {
  label: string
  value: DateFilter
  placeholder?: string
  onRemove: () => void
  onChange: (value: DateFilter) => void
}

const GiftCardFilterDateField: React.FC<
  GiftCardFilterDateFieldProps
> = props => {
  const { label, value, placeholder, onChange, onRemove } = props

  const [isCalendarOpen, setIsCalendarOpen] = useState(true)

  const stopBuble = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }

  const handleCloseCalendar = () => {
    setIsCalendarOpen(false)
  }

  const handleOnFocus = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setIsCalendarOpen(!isCalendarOpen)
  }

  const handleSubmit = (start?: Moment, end?: Moment) => {
    if (start?.toString() === end?.toString()) {
      onChange({
        eq: start?.format('YYYY-MM-DD') ?? '',
      })
    } else {
      onChange({
        gte: start?.format('YYYY-MM-DD') ?? '',
        lte: end?.format('YYYY-MM-DD') ?? '',
      })
    }
  }

  const getDateValueString = (_value: string) => {
    return moment(_value).format('MMM-DD')
  }

  return (
    <div className={styles.wrapper} onClick={handleOnFocus}>
      <div>
        <Text type="caption" weight="semiBold" content={`${label}:`} />
      </div>
      <div className={styles.dateRangeValue}>
        <Text type="caption">
          {value?.eq
            ? getDateValueString(value.eq)
            : value?.gte && value?.lte
              ? `${getDateValueString(value.gte)} - ${getDateValueString(value.lte)}`
              : (placeholder ?? 'Add Dates...')}
        </Text>
      </div>
      {isCalendarOpen && (
        <div className={styles.calendarDropDown} onClick={stopBuble}>
          <CalendarDateRangePicker
            onCancel={handleCloseCalendar}
            onSubmit={(start, end) => {
              handleSubmit(start, end)
              setIsCalendarOpen(false)
            }}
            shouldHideYear={true}
          />
        </div>
      )}
      <CloseButton onClose={onRemove} size={18} />
    </div>
  )
}

export default GiftCardFilterDateField
